<template>
  <div class="top-middle-cmp-all box box_v">

    <div class="top-middle-cmp box_f1 box box_v">
      <div class="tuli box box_i_center">
        <span class="tuli_icon" style="background-color:#f5d94e "></span><span class="tuli_title">金银珠宝</span>
        <span class="tuli_icon" style="background-color:#00f52e "></span><span class="tuli_title">家电</span>
        <span class="tuli_icon" style="background-color:#f54500 "></span><span class="tuli_title">超市</span>
        <span class="tuli_icon" style="background-color:#0800f5 "></span><span class="tuli_title">百货餐饮</span>
      </div><!--2个超市和商场的-->
      <div class="chart-name">
        当日核销数
        <dv-decoration-3 style="width:100px;height:15px;" />
      </div>
      <div class="box_f1" style="position: relative;">
        <div class="charDiv">
          <dv-charts :option="countHourOption" />
        </div>
      </div>
    </div>



    <div class="top-middle-cmp box_f1">
      <div class="chart-name">
        拉动消费额
        <dv-decoration-3 style="width:100px;height:15px;" />
      </div>
      <dv-charts :option="countConsumeOption" />
    </div>

    <div class="top-middle-cmp box_f1 box box_v">
      <div class="tuli box box_i_center">
        <span class="tuli_icon" style="background-color:#f5d94e "></span><span class="tuli_title">金银珠宝</span>
        <span class="tuli_icon" style="background-color:#00f52e "></span><span class="tuli_title">家电</span>
        <span class="tuli_icon" style="background-color:#f54500 "></span><span class="tuli_title">超市</span>
        <span class="tuli_icon" style="background-color:#0800f5 "></span><span class="tuli_title">百货餐饮</span>
      </div><!--2个超市和商场的-->
      <div class="chart-name">
        每日核销数
        <dv-decoration-3 style="width:100px;height:15px;" />
      </div>
      <div class="box_f1" style="position: relative;">
        <div class="charDiv">
          <dv-charts :option="countDayOption" />
        </div>
      </div>
    </div>


  </div>


</template>

<script>
    export default {
      name: "centerCharts",
      computed: {
        xiaofeiquanVue() {
          return this.$store.state.xiaofeiquanVue
        },
      },
      created() {
        this.load()
      },
      methods: {
        load() {
          //GET /api/coupon-count/ctt2/amount/count4line
          //消费金额统计--当日(08~22点)/每日 拉动消费额线型图（按照时间/日期正序无间隔排列）
          let time = new Date().getTime()
          let date = this.$util.FormatDate(time, "yyyy-MM-dd")
          // this.xiaofeiquanVue.loopAxios('demo/api/coupon-count/ctt2/amount/count4line',{
          //   beginDate: date,
          //   endDate: date
          // },res=> {
          {
              let res = {"isSucceed":true,"message":"","rows":[{"dateTime":"08:00","amount":17270.24},{"dateTime":"09:00","amount":136849.23},{"dateTime":"10:00","amount":442541.83},{"dateTime":"11:00","amount":392799.78},{"dateTime":"12:00","amount":248367.27},{"dateTime":"13:00","amount":224925.59},{"dateTime":"14:00","amount":282525.47},{"dateTime":"15:00","amount":424638.85},{"dateTime":"16:00","amount":437914.58},{"dateTime":"17:00","amount":539042.36},{"dateTime":"18:00","amount":465715.18},{"dateTime":"19:00","amount":278757.59},{"dateTime":"20:00","amount":309270.69},{"dateTime":"21:00","amount":192807.73},{"dateTime":"22:00","amount":4809.8}],"footer":[],"total":null,"newPrimaryKeys":{},"mqObj":null,"code":1}
              let xAxis_data = []
              let series_0_data = []
              for(let i = 0; i < res.rows.length; i++) {
                series_0_data.push(res.rows[i].amount)
                xAxis_data.push(res.rows[i].dateTime)
              }
              this.countConsumeOption = this.oneOption(xAxis_data, series_0_data)
          }
          // })
          //核销数统计--当日(08~22点)/每日 核销数线型图（按照时间/日期正序无间隔排列
          // this.xiaofeiquanVue.loopAxios('demo/api/coupon-count/ctt2/consume/count4line',{
          //   beginDate: date,
          //   endDate: date
          // },res=> {
          {
            let res = {"isSucceed":true,"message":"","rows":[{"dateTime":"08:00","supermarketConsumeNum":24,"marketConsumeNum":0,"jewelryConsumeNum":0,"deviceConsumeNum":8},{"dateTime":"09:00","supermarketConsumeNum":424,"marketConsumeNum":138,"jewelryConsumeNum":0,"deviceConsumeNum":51},{"dateTime":"10:00","supermarketConsumeNum":489,"marketConsumeNum":657,"jewelryConsumeNum":4,"deviceConsumeNum":201},{"dateTime":"11:00","supermarketConsumeNum":554,"marketConsumeNum":812,"jewelryConsumeNum":2,"deviceConsumeNum":142},{"dateTime":"12:00","supermarketConsumeNum":270,"marketConsumeNum":610,"jewelryConsumeNum":9,"deviceConsumeNum":45},{"dateTime":"13:00","supermarketConsumeNum":152,"marketConsumeNum":650,"jewelryConsumeNum":3,"deviceConsumeNum":43},{"dateTime":"14:00","supermarketConsumeNum":212,"marketConsumeNum":692,"jewelryConsumeNum":9,"deviceConsumeNum":64},{"dateTime":"15:00","supermarketConsumeNum":551,"marketConsumeNum":932,"jewelryConsumeNum":0,"deviceConsumeNum":150},{"dateTime":"16:00","supermarketConsumeNum":341,"marketConsumeNum":1089,"jewelryConsumeNum":2,"deviceConsumeNum":142},{"dateTime":"17:00","supermarketConsumeNum":538,"marketConsumeNum":1140,"jewelryConsumeNum":7,"deviceConsumeNum":174},{"dateTime":"18:00","supermarketConsumeNum":689,"marketConsumeNum":1234,"jewelryConsumeNum":0,"deviceConsumeNum":157},{"dateTime":"19:00","supermarketConsumeNum":561,"marketConsumeNum":803,"jewelryConsumeNum":7,"deviceConsumeNum":64},{"dateTime":"20:00","supermarketConsumeNum":780,"marketConsumeNum":1138,"jewelryConsumeNum":0,"deviceConsumeNum":34},{"dateTime":"21:00","supermarketConsumeNum":418,"marketConsumeNum":667,"jewelryConsumeNum":0,"deviceConsumeNum":17},{"dateTime":"22:00","supermarketConsumeNum":4,"marketConsumeNum":26,"jewelryConsumeNum":0,"deviceConsumeNum":0}],"footer":[],"total":null,"newPrimaryKeys":{},"mqObj":null,"code":1}
            let xAxis_data = []
            let series_0_data = []
            let series_1_data = []
            let series_2_data = []
            let series_3_data = []
            for(let i = 0; i < res.rows.length; i++) {
              series_0_data.push(res.rows[i].jewelryConsumeNum)
              series_1_data.push(res.rows[i].deviceConsumeNum)
              series_2_data.push(res.rows[i].supermarketConsumeNum)
              series_3_data.push(res.rows[i].marketConsumeNum)
              if(xAxis_data.indexOf(res.rows[i].dateTime)==-1) {
                xAxis_data.push(res.rows[i].dateTime)
              }
            }
            this.countHourOption = this.twoOption(xAxis_data, series_0_data, series_1_data, series_2_data, series_3_data)
          }
            // })

          // this.xiaofeiquanVue.loopAxios('demo/api/coupon-count/ctt2/consume/count4line',{
          //   beginDate: '2020-09-22',
          //   endDate: '2020-10-08'
          // },res=> {
          {
            let res = {"isSucceed":true,"message":"","rows":[{"dateTime":"09-22","supermarketConsumeNum":3887,"marketConsumeNum":1374,"jewelryConsumeNum":27,"deviceConsumeNum":153},{"dateTime":"09-23","supermarketConsumeNum":7380,"marketConsumeNum":5711,"jewelryConsumeNum":55,"deviceConsumeNum":654},{"dateTime":"09-24","supermarketConsumeNum":7645,"marketConsumeNum":4985,"jewelryConsumeNum":53,"deviceConsumeNum":562},{"dateTime":"09-25","supermarketConsumeNum":7471,"marketConsumeNum":5874,"jewelryConsumeNum":40,"deviceConsumeNum":765},{"dateTime":"09-26","supermarketConsumeNum":6807,"marketConsumeNum":7233,"jewelryConsumeNum":60,"deviceConsumeNum":793},{"dateTime":"09-27","supermarketConsumeNum":6825,"marketConsumeNum":6927,"jewelryConsumeNum":63,"deviceConsumeNum":868},{"dateTime":"09-28","supermarketConsumeNum":6199,"marketConsumeNum":7087,"jewelryConsumeNum":42,"deviceConsumeNum":483},{"dateTime":"09-29","supermarketConsumeNum":6555,"marketConsumeNum":6461,"jewelryConsumeNum":22,"deviceConsumeNum":720},{"dateTime":"09-30","supermarketConsumeNum":7176,"marketConsumeNum":7101,"jewelryConsumeNum":40,"deviceConsumeNum":802},{"dateTime":"10-01","supermarketConsumeNum":5599,"marketConsumeNum":7945,"jewelryConsumeNum":49,"deviceConsumeNum":874},{"dateTime":"10-02","supermarketConsumeNum":5321,"marketConsumeNum":8408,"jewelryConsumeNum":69,"deviceConsumeNum":869},{"dateTime":"10-03","supermarketConsumeNum":5705,"marketConsumeNum":9016,"jewelryConsumeNum":50,"deviceConsumeNum":1146},{"dateTime":"10-04","supermarketConsumeNum":5931,"marketConsumeNum":10733,"jewelryConsumeNum":60,"deviceConsumeNum":1261},{"dateTime":"10-05","supermarketConsumeNum":6007,"marketConsumeNum":10588,"jewelryConsumeNum":43,"deviceConsumeNum":1292},{"dateTime":"10-06","supermarketConsumeNum":2742,"marketConsumeNum":5411,"jewelryConsumeNum":21,"deviceConsumeNum":672},{"dateTime":"10-07","supermarketConsumeNum":720,"marketConsumeNum":1253,"jewelryConsumeNum":16,"deviceConsumeNum":175},{"dateTime":"10-08","supermarketConsumeNum":627,"marketConsumeNum":1226,"jewelryConsumeNum":4,"deviceConsumeNum":186}],"footer":[],"total":null,"newPrimaryKeys":{},"mqObj":null,"code":1}
            let xAxis_data = []
            let series_0_data = []
            let series_1_data = []
            let series_2_data = []
            let series_3_data = []
            for (let i = 0; i < res.rows.length; i++) {
              series_0_data.push(res.rows[i].jewelryConsumeNum)
              series_1_data.push(res.rows[i].deviceConsumeNum)
              series_2_data.push(res.rows[i].supermarketConsumeNum)
              series_3_data.push(res.rows[i].marketConsumeNum)
              if (xAxis_data.indexOf(res.rows[i].dateTime) == -1) {
                xAxis_data.push(res.rows[i].dateTime)
              }
            }
            this.countDayOption = this.twoOption(xAxis_data, series_0_data, series_1_data, series_2_data, series_3_data)

          }
          // })
        },
        oneOption(xAxis_data, series_0_data) {
          if(xAxis_data.length===0) {
            return {}
          }else if(xAxis_data.length===1) {
            xAxis_data.unshift('')
            series_0_data.unshift(0)
            xAxis_data.push('')
            series_0_data.push(0)
          }else if(xAxis_data.length===2) {
            xAxis_data.unshift('')
            series_0_data.unshift(0)
          }
          return {
            grid: {
              top: 30,
              // left: 30,
              right: 0,
              bottom: 30
            },
            xAxis: {
              data: xAxis_data,
              axisLine: {
                style: {
                  stroke: '#ccc'
                }
              },
              axisLabel: {
                style: {
                  fill: '#ccc'
                }
              },
              axisTick: {
                show: false
              }
            },
            yAxis: {
              data: 'value',
              min: 0,
              splitLine: {
                show: false
              },
              axisLine: {
                style: {
                  stroke: '#ccc'
                }
              },
              axisLabel: {
                style: {
                  fill: '#ccc'
                }
              },
              axisTick: {
                show: false
              }
            },
            series: [
              {
                data: series_0_data,
                type: 'line',
                smooth: true,
                lineArea: {
                  show: true,
                  gradient: ['rgba(55, 162, 218, 0.6)', 'rgba(55, 162, 218, 0)']
                },
                lineStyle: {
                  lineDash: [5, 5]
                },
                linePoint: {
                  radius: 3,
                  style: {
                    fill: '#00db95'
                  }
                }
              }
            ]
          }
        },
        twoOption(xAxis_data, series_0_data, series_1_data, series_2_data, series_3_data) {
          if(xAxis_data.length===0) {
            return {}
          }else if(xAxis_data.length===1) {
            xAxis_data.unshift('')
            series_0_data.unshift(0)
            series_1_data.unshift(0)
            series_2_data.unshift(0)
            series_3_data.unshift(0)
            xAxis_data.push('')
            series_0_data.push(0)
            series_1_data.push(0)
            series_2_data.push(0)
            series_3_data.push(0)
          }else if(xAxis_data.length===2) {
            xAxis_data.unshift('')
            series_0_data.unshift(0)
            series_1_data.unshift(0)
            series_2_data.unshift(0)
            series_3_data.unshift(0)
          }
          return {
            grid: {
              top: 20,
              // left: 30,
              right: 0,
              bottom: 30
            },
            xAxis: {
              data: xAxis_data,
              axisLine: {
                style: {
                  stroke: '#ccc'
                }
              },
              axisLabel: {
                style: {
                  fill: '#ccc'
                }
              },
              axisTick: {
                show: false
              }
            },
            yAxis: {
              data: 'value',
              min: 0,
              splitLine: {
                show: false
              },
              axisLine: {
                style: {
                  stroke: '#ccc'
                }
              },
              axisLabel: {
                style: {
                  fill: '#ccc'
                }
              },
              axisTick: {
                show: false
              }
            },
            series: [
              {
                name: '金银珠宝',
                data: series_0_data,
                type: 'line',
                smooth: true,
                lineArea: {
                  show: true,
                  gradient: ['rgba(245, 217, 78, 0.6)', 'rgba(245, 217, 78, 0)']
                },
                lineStyle: {
                  stroke: '#f5d94e',
                  lineDash: [5, 5]
                },
                linePoint: {
                  radius: 3,
                  style: {
                    fill: '#f5d94e',
                    stroke: 'transparent'
                  }
                }
              },
              {
                data: series_1_data,
                type: 'line',
                smooth: true,
                name: '家电',
                lineArea: {
                  show: true,
                  gradient: ['rgba(0, 245, 46, 0.6)', 'rgba(0, 245, 46, 0)']
                },
                lineStyle: {
                  stroke: '#00f52e'
                },
                linePoint: {
                  radius: 3,
                  style: {
                    fill: '#00f52e',
                    stroke: 'transparent'
                  }
                }
              },
              {
                data: series_2_data,
                type: 'line',
                smooth: true,
                name: '超市',
                lineArea: {
                  show: true,
                  gradient: ['rgba(245, 69, 0, 0.6)', 'rgba(245, 69, 0, 0)']
                },
                lineStyle: {
                  stroke: '#f54500'
                },
                linePoint: {
                  radius: 3,
                  style: {
                    fill: '#f54500',
                    stroke: 'transparent'
                  }
                }
              },
              {
                data: series_3_data,
                type: 'line',
                smooth: true,
                name: '百货餐饮',
                lineArea: {
                  show: true,
                  gradient: ['rgba(8, 0, 245, 0.6)', 'rgba(8, 0, 245, 0)']
                },
                lineStyle: {
                  stroke: '#0800f5'
                },
                linePoint: {
                  radius: 3,
                  style: {
                    fill: '#0800f5',
                    stroke: 'transparent'
                  }
                }
              }
            ]
          }
        }
      },
      data() {
        return {
          countHourOption: {},
          countConsumeOption: {},
          countDayOption: {}
        }
      }
    }
</script>

<style lang="less">
  .top-middle-cmp-all {
      position: relative;
      height: 100%;
      width: 100%;
      box-sizing: border-box;

    .top-middle-cmp {
      position: relative;
      box-sizing: border-box;
      width: 100%;
      /*border: 1px solid #f20;*/
      /*overflow: hidden;*/
      .chart-name {
        position: absolute;
        right: 10px;
        top: 10px;
        text-align: right;
        font-size: 15px;
      }

      .tuli{
        position: absolute;
        right: 100px;
        top: 12px;
        .tuli_icon {
          display: block;
          width: 10px;
          height: 10px;
          border-radius: 10px;
          margin-right: 5px;
        }
        .tuli_title {
          font-size: 13px;
          margin-right: 5px;
        }
      }

      .charDiv {
        position: absolute;
        left: 0;
        top: 0;
        bottom:0;
        right:0;
      }

    }
  }

</style>
